import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import OneSignal from 'react-onesignal'
import authService from './services/authService'

function App() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  // <!-- OneSignal Push Notification -->
  useEffect(() => {
    const initNotifications = async () => {
      const connected = await authService.isOnline()
      if (connected) {
        setTimeout(() => {
          OneSignal.init({
            appId: process.env.REACT_APP_ID_ONESIGNAL,
            safari_web_id: process.env.REACT_APP_SAFARI_WEB_ID_ONESIGNAL,
            notifyButton: {
              enable: true,
              size: 'medium', // small, medium, large
              // theme: 'default', // default, inverse
              // position: 'bottom-right', // top-left, top-right, bottom-left, bottom-right
              offset:
                window.innerWidth <= 639
                  ? { bottom: '85px', right: '20px' }
                  : undefined,
              // colors: {
              //   'circle.background': '#4CAF50',
              //   'circle.foreground': '#ffffff',
              //   'badge.background': '#ff5252',
              //   'badge.foreground': '#ffffff',
              //   'pulse.color': '#4CAF50',
              // },
              text: {
                'tip.state.unsubscribed':
                  'Cliquez pour activer les notifications',
                'tip.state.subscribed': 'Vous recevez déjà nos notifications',
                'tip.state.blocked': 'Notifications bloquées',
                'message.prenotify': 'Voulez-vous recevoir nos notifications ?',
                'dialog.main.title': 'Gérer les notifications',
                'dialog.main.button.subscribe': 'Activer',
                'dialog.main.button.unsubscribe': 'Désactiver',
                'dialog.blocked.title': 'Notifications bloquées',
                'dialog.blocked.message':
                  'Vous avez bloqué les notifications pour ce site. Veuillez les activer dans votre navigateur.',
              },
            },
            serviceWorkerPath: 'sw.js',
            serviceWorkerUpdaterPath: 'sw.js',
            serviceWorkerParam: { scope: '/' },
            welcomeNotification: {
              disable: true,
            },
          }).then(() => {
            // 'none' → aucun log
            // 'error' → seulement les erreurs
            // 'warn' → erreurs + warnings
            // 'info' → infos + warnings + erreurs
            // 'trace' → tout (utile pour debug)
            OneSignal.Debug.setLogLevel('none')
          })
        }, 2000)
      }
    }

    initNotifications()
  }, [])

  return (
    <>
      <ScrollToTop />
      <div style={{ minHeight: '70vh' }}>
        <Outlet />
      </div>
    </>
  )
}

export default App
